import { Tooltip, Button } from 'antd';
import { Translate } from '@above-the-treeline/localization';
import { useTitle } from './containers/TitleDataStore';
import TitleDetailJacketFrame from './TitleDetailJacketFrame';
import { withIsMobile } from 'treeline-react-core-components/WindowSizeProvider';
import LoadingSpinnerInContainer from '../UI/LoadingSpinnerInContainer/LoadingSpinnerInContainer';

type TitleDetailJacketProps = {
	doShowSmallJacket?: boolean;
	setDoShowTitleJacket: (doShowTitleJacket: boolean) => void;
	setDoShowSmallJacket?: (
		doShowSmallJacket: boolean | ((doShowSmallJacket: boolean) => boolean),
	) => void;
	isMobile: () => boolean;
};

const TitleDetailJacket = ({
	doShowSmallJacket,
	setDoShowTitleJacket,
	setDoShowSmallJacket,
	isMobile,
}: TitleDetailJacketProps) => {
	const {
		state: { isProductDataLoading },
	} = useTitle();
	const isMobileSize = isMobile();

	const getJacketSizeTooltip = () =>
		doShowSmallJacket ? (
			<Translate id="show_larger_jacket_cover" />
		) : (
			<Translate id="show_smaller_jacket_cover" />
		);

	return isProductDataLoading ? (
		<LoadingSpinnerInContainer height={100} />
	) : (
		<>
			<TitleDetailJacketFrame
				setDoShowTitleJacket={setDoShowTitleJacket}
			/>
			{!isMobileSize && (
				<div className="jacket-size-frame">
					<Tooltip
						overlayClassName="title-detail jacket-size-tooltip"
						title={getJacketSizeTooltip()}
						placement="bottomRight">
						<Button shape="circle">
							<div
								className={
									doShowSmallJacket
										? 'icon-expand'
										: 'icon-compress'
								}
								onClick={() =>
									setDoShowSmallJacket &&
									setDoShowSmallJacket(
										(prev: boolean) => !prev,
									)
								}
							/>
						</Button>
					</Tooltip>
				</div>
			)}
		</>
	);
};

export default withIsMobile(TitleDetailJacket);
